/* Component in the Scene Component to display the 
   Scene Breakdown info */
import React from "react";

import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useHistory } from "react-router-dom";
import { useCurrentUser } from "../../../contexts/CurrentUserContext";

import styles from "../../../styles/Scene.module.css";
import btnStyles from "../../../styles/Button.module.css";

const Breakdown = (props) => {
  const currentUser = useCurrentUser();
  const projectType = currentUser?.project_category_type
    ? JSON.parse(currentUser?.project_category_type)
    : null;

  const history = useHistory();
  const queryString = window.location.search;

  // Use URLSearchParams to parse the query string
  const params = new URLSearchParams(queryString);
  // Retrieve the "episode" parameter
  const episode = params.get("episode");
  const project = params.get("project");
  const episodeTitle = params.get("episodeTitle");

  const handleEdit = () => {
    history.push(
      `/${localStorage.getItem("projectSlug")}/scenes/${id}/edit${
        episode && project && episodeTitle
          ? `?episode=${episode}&project=${project}&episodeTitle=${episodeTitle}`
          : ""
      }`
    );
  };

  const {
    id,
    title,
    act,
    int_ext,
    day_night,
    time,
    location,
    location_detail,
    pages,
    action,
    filming_location,
    shooting_date,
    dramatic_day,
    equip_set_props,
    department_info,
    setShowBreak,
    number,
  } = props;

  const dayNight = day_night.toLowerCase();

  return (
    <div className={`${styles.FontGrey} pb-5`}>
      <h5
        style={{ textTransform: "uppercase" }}
        className={`mt-1 pl-5 py-1 text-center ${styles.SubTitle}`}
      >
        Scene {number} Breakdown
        <span
          style={{ textTransform: "none" }}
          className={`float-right pt-1 ${styles.Close}`}
          onClick={() => setShowBreak(false)}
        >
          Close
        </span>
      </h5>
      <Row>
        {currentUser &&
          currentUser?.groups.length > 0 &&
          (currentUser?.groups[0]?.name === "Admin" ||
            currentUser?.groups[0]?.name === "Superadmin" ||
            currentUser?.groups[0]?.name === "Admincreative") && (
              <>
            <Col className="pt-2 pb-2 text-center">
              <Button
                className={`px-1 px-md-3 py-0 ${btnStyles.GreyDark} ${btnStyles.Button}`}
                onClick={handleEdit}
              >
                ADD / UPDATE
              </Button>
            </Col>
            </>
          )}
      </Row>
      {/* location */}
      <Row>
            <Col className={`${styles.BorderRight} text-center `} xs={12} md={6}>
            <p className={`${styles.BoldTitle} 
            text-center mx-1 mx-sm-5 mb-2`}>INT-EXT / DAY-NIGHT</p>
            <div className={`${styles.Div30}`}>
            <p style={{ textTransform: 'capitalize'}} >
            {int_ext} {dayNight}
            </p>
            </div>
            <Row className="d-block d-md-none">
            <Col xs={{span: 10, offset: 1 }}>
            <hr className={`mt-0 mb-1`}/>
            </Col>
            </Row>
            </Col>
            <Col className='text-center px-3' xs={12} md={6}>
            <p className={`${styles.BoldTitle} 
            text-center mx-1 mx-sm-5 mb-2`}>LOCATION</p>
            <div className={`${styles.Div30}`}>
            <p >
            {location}
            </p>
            </div>
            </Col>
            </Row>
            <Row>
            <Col xs={{span: 10, offset: 1 }} 
                md={{span: 6, offset: 3 }}>
            <hr className={`mt-0 mb-0`}/>
            </Col>
            </Row>
            {/* action  */}
            <Row className='mt-1 mt-md-3'>
              <Col className={`text-center ${styles.BorderRight}`} xs={12} md={6}>
                <p className={`${styles.BoldTitle} 
                mb-2 text-center mx-1 mx-sm-5`}>HEADING INFO </p>
                <div className={`${styles.Div30}`}>
                <p>{title}</p>
                </div>
                <Row className="d-block d-md-none">
                <Col xs={{span: 10, offset: 1 }}>
                <hr className={`mt-0 mb-0`}/>
                </Col>
                </Row>
            </Col>
            <Col className={`${styles.BorderRight} mt-1 mt-md-0 text-center `} xs={12} md={6} >
            <p className={`${styles.BoldTitle} 
            mb-2 text-center mx-1 mx-sm-5`}>ACTION</p>
            <div className={`${styles.Div30}`}>
            <p>{action} </p>
            </div>
            </Col>
            </Row>
            {/* hr */}
            <Row>
            <Col xs={{span: 10, offset: 1 }}>
            <hr className={`mt-0 mb-0`}/>
            </Col>
            </Row>
            {/* EQUIPMENT - VFX */}
            <Row className='mt-1 mt-md-3'>
                <Col className={`text-center ${styles.BorderRight}`} xs={12} md={6}>
                <p className={`${styles.BoldTitle} 
                mb-2 text-center mx-1 mx-sm-5`}>EQUIPMENT SET PROPS</p>
                <div className={`${styles.Div30}`}>
                <p>{equip_set_props} </p>
                </div>
                <Row className="d-block d-md-none">
                <Col xs={{span: 10, offset: 1 }}>
                <hr className={`mt-0 mb-0`}/>
                </Col>
                </Row>
                </Col>
                <Col className='text-center mt-1 mt-md-0' xs={12} md={6}>
                <p className={`${styles.BoldTitle} 
                mb-2 text-center mx-1 mx-sm-5`}>STUNTS / SFX / VFX</p>
                <div className={`${styles.Div30}`}>
                <p>{location_detail} </p>
                </div>
                </Col>
            </Row>
            {/* hr */}
            <Row>
            <Col xs={{span: 10, offset: 1 }}>
            <hr className={`mt-0 mb-0`}/>
            </Col>
            </Row>
            {/* Story/Editing - */}
            <Row className='mt-1 mt-md-3'>
              <Col className={`text-center ${styles.BorderRight}`} xs={12} md={6} >
              <p className={`${styles.BoldTitle} 
              mb-2 text-center mx-1 mx-sm-5`}>STORY / EDITING</p>
              <div className={`${styles.Div30}`}>
              <p>{time} </p>
              </div>
              <Row className="d-block d-md-none">
                <Col xs={{span: 10, offset: 1 }}>
                <hr className={`mt-0 mb-0`}/>
                </Col>
                </Row>
              </Col>
              <Col className={`text-center mt-1 mt-md-0`} xs={12} md={6}>
              <p className={`${styles.BoldTitle} 
              mb-2 text-center mx-1 mx-sm-5`}>POST SOUND / MUSIC</p>
              <div className={`${styles.Div30}`}>
              <p>{shooting_date} </p>
              </div>
              </Col>
            </Row>
            {/* hr */}
            <Row>
            <Col xs={{span: 10, offset: 1 }}>
            <hr className={`mt-0 mb-0`}/>
            </Col>
            </Row>
            {/* act pages */}
            {projectType !== "Television" ? (
            <Row className='mt-1 mt-md-3' >
            <Col className={`${styles.BorderRight} text-center`} xs={4}>
            <p className={`${styles.BoldTitle} 
            mb-2 text-center mx-1 mx-sm-5`}>ACT</p>
            <div className={`${styles.Div30}`}>
            <p style={{ textTransform: 'capitalize'}}>{act} </p>
            </div>
            </Col>
            <Col className={`${styles.BorderRight} text-center`} xs={4}>
            <p className={`${styles.BoldTitle} 
            mb-2 text-center mx-1 mx-sm-5`}>PAGES</p>
            <div className={`${styles.Div30}`}>
            <p>{pages} </p>
            </div>
            </Col>
            <Col className={`${styles.BorderRight} text-center`} xs={4}>
            <p className={`${styles.BoldTitle} d-none d-md-block
            mb-2 text-center mx-1 mx-sm-5`}>DRAMATIC DAY</p>
            <p className={`${styles.BoldTitle} d-block d-md-none
            mb-2 text-center mx-1 mx-sm-5`}>D. DAY</p>
            <div className={`${styles.Div30}`}>
            <p >{dramatic_day} </p>
            </div>
            </Col>
            </Row>
            ) : (
            <Row className='mt-1 mt-md-3' >
            <Col className={`${styles.BorderRight} text-center`} xs={6}>
            <p className={`${styles.BoldTitle} 
            mb-2 text-center mx-1 mx-sm-5`}>PAGES</p>
            <div className={`${styles.Div30}`}>
            <p>{pages} </p>
            </div>
            </Col>
            <Col className={`${styles.BorderRight} text-center`} xs={6}>
            <p className={`${styles.BoldTitle} d-none d-md-block
            mb-2 text-center mx-1 mx-sm-5`}>DRAMATIC DAY</p>
            <p className={`${styles.BoldTitle} d-block d-md-none
            mb-2 text-center mx-1 mx-sm-5`}>D. DAY</p>
            <div className={`${styles.Div30}`}>
            <p >{dramatic_day} </p>
            </div>
            </Col>
            </Row>
            )}
            {/* hr */}
            <Row>
            <Col xs={{span: 10, offset: 1 }}>
            <hr className={`mt-0 mb-0`}/>
            </Col>
            </Row>
            {/* depts info */}
            <Row className='mt-1 mt-md-3'>
                <Col className='text-center' xs={{span: 10, offset: 1 }} 
                md={{span: 8, offset: 2 }}>
                <p className={`${styles.BoldTitle} 
                mb-2 text-center mx-1 mx-sm-5`}>DEPARTMENTS/SHOOT INFO </p>
                <div className={`${styles.Div30}`}>
                <p>{department_info} </p>
                </div>
                </Col>
            </Row>
            <Row>
            <Col xs={{span: 10, offset: 1 }}>
            <hr className={`mt-0 mb-0`}/>
            </Col>
            </Row>
            {/* big break */}
            <Row className='my-5'>
            <Col xs={2} ></Col>
            <Col xs={8}>
            <hr className={`${styles.Break} mt-0 mb-0 mb-md-1`}/>
            <hr className={`${styles.BreakBlack} my-0`}/>
            </Col>
            </Row>
    </div>
  );
};

export default Breakdown;
